module.exports = __webpack_public_path__ + "img/logo.fb1cc74a.svg";